module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/group-30@2x.c746a692.png";